<template>
  <v-text-field :value="amount"              
                :label="label"
                v-on:keydown="onKeydown($event)" 
                v-on:focus="onGetFocus($event)" 
                v-on:change="updateData" dense :prefix="prefix" 
                :class="{'text-field-style': isReadOnly, 'text-grey': isReadOnly, 'amount-alignment': true, 'input-align-right': true}">
  </v-text-field> 
</template>

<script>
  export default {
    props: {
      amount: String,
      label: String,
      prefix: String,
      element: Number,
      isDense:{
          type: Boolean,
          default: true
        },
        isReadOnly: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
      }
    }, 
    methods:{
      onGetFocus(evt){
        try{
          evt.target.select();
        } catch(err){ 
          console.log(err);
        }
      }, 
      onKeydown(e) {
        let allowedalphakeys = [8, 9, 188, 46, 35, 36, 37, 39];
        let allowedctrlkeys = [65, 67, 88, 86];
        let allowednumpadkeys = [35, 36, 37, 39];
        if (!(
            ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey)
            || (e.keyCode == 189 && !e.shiftKey)
            || (e.keyCode >= 96 && e.keyCode <= 105)
            || allowedalphakeys.includes(e.keyCode)
            || (allowedctrlkeys.includes(e.keyCode) && e.ctrlKey)
            || (allowednumpadkeys.includes(e.keyCode) && e.shiftKey)
        )) {
            e.preventDefault();
        }          
      },
      toDutchNumberFormat(value) {
        // decimal seperator must be "," for input value
        if(value != null && value != '' && value != '0') {    
            if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
            } 
            return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);
        } else {
            return '0';
        }
      },      
      updateData(v){        
        this.$emit('updateData', {value: this.toDutchNumberFormat(v), element: this.element});
      }       
    }    
  }
</script>

<style scoped>
  .amount-alignment{
    text-align: right;
  }

  .input-align-right >>> input {
    text-align: right;
  }

</style>